import { type Exact } from "../types";

export enum GlobalEvents {
  CartAdd = "ploom:cart:add",
  CartIdLoaded = "ploom:cart:id:init",
  CartIsActive = "ploom:cart:active",
  ConsentsUpdated = "jti:consents-updated",
  InfoBannerStateChange = "ploom:infobanner:active:changed:success",
  ProductLimitReached = "ploom:product:limit:reached",
  StopVideo = "ploom:video:stop",
  UpdateLoyaltyPoints = "update:loyalty:points",
}

type GlobalEventsAdditionalData = {
  [GlobalEvents.ConsentsUpdated]: { uuid: string };
  [GlobalEvents.StopVideo]: { videoId: string }; // FIXME no listeners added for this one
};

const createCustomEvent = <
  EventName extends GlobalEvents,
  Additional = EventName extends keyof GlobalEventsAdditionalData ? GlobalEventsAdditionalData[EventName] : never,
>(
  eventName: EventName,
  additionalData: Additional
): CustomEvent<{ additionalData: Additional }> => {
  return new CustomEvent(eventName, {
    detail: {
      additionalData,
    },
  });
};

export function dispatchCustomEvent<
  EventName extends GlobalEvents,
  Additional extends (EventName extends keyof GlobalEventsAdditionalData
    ? GlobalEventsAdditionalData[EventName]
    : never),
  T,
>(eventName: EventName, additionalData?: Exact<T, Additional>): Promise<void> {
  if (typeof document === "undefined") {
    return Promise.resolve();
  }
  const event = createCustomEvent(eventName, additionalData);
  document.dispatchEvent(event);
  return new Promise((resolve) => setTimeout(resolve, 500));
}
